/**
 * Health Service
 * 
 * API calls for health check and server status
 */

import api from './api';

const healthService = {
  /**
   * Check API server health
   * @returns {Promise} Health status data
   */
  checkHealth: async () => {
    try {
      const response = await api.get('/health');
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default healthService;
